import { RequirementDefinitionAutoLiabilityFormValues } from "../../../../types";
import { formatLimit } from "./formatLimit";

export const getAutoLiabilitySettings = (
  settings: Partial<RequirementDefinitionAutoLiabilityFormValues>
): string[] => {
  const items: string[] = [];

  if (settings.coverageLimitMinimum) {
    items.push(`Coverage limit: ${formatLimit(settings.coverageLimitMinimum)}`);
  }

  return items.length > 0 ? items : ["No coverages configured"];
};
